// src/pages/Team.tsx
import Sidebar from "../components/Sidebar";
import DashboardTopbar from "../components/DashboardTopbar";

const Team = () => {
  const staff = [
    { name: "Sasha Kim", role: "Manager", email: "sasha@fullplatenow.com" },
    { name: "Tyree Cooper", role: "Support", email: "tyree@fullplatenow.com" },
  ];

  return (
    <div className="flex min-h-screen">
      <Sidebar />
      <div className="flex-1 bg-[#f9f9f9]">
        <DashboardTopbar
          logoUrl="/logo.png"
          name="FullPlateNow Restaurant"
          address="123 Main St, Springfield"
        />
        <div className="p-6">
          <h2 className="text-2xl font-bold mb-4">Team Members</h2>
          <table className="w-full text-sm text-left bg-white shadow rounded-xl overflow-hidden">
            <thead className="bg-[#f3f3f3] text-gray-700">
              <tr>
                <th className="px-4 py-3">Name</th>
                <th className="px-4 py-3">Role</th>
                <th className="px-4 py-3">Email</th>
              </tr>
            </thead>
            <tbody>
              {staff.map((member) => (
                <tr key={member.email} className="border-t">
                  <td className="px-4 py-3">{member.name}</td>
                  <td className="px-4 py-3">{member.role}</td>
                  <td className="px-4 py-3">{member.email}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Team;
